const faqData = [
  {
    q: '情侣影院真的完全免费吗？',
    a: '是的，情侣影院所有电视剧全集和最新电视剧均支持免费在线观看，无需注册登录，也无需付费会员。我们通过广告合作来维持平台运营，确保每一对情侣都能无障碍地享受高清追剧体验。国产剧全集和韩剧全集全部免费开放。',
  },
  {
    q: '电视剧更新速度如何？能看到最新剧集吗？',
    a: '情侣影院保持每日同步更新最新电视剧的节奏。热门国产剧和韩剧一般在电视台或流媒体平台播出后24小时内上线，确保你不会错过任何一集精彩内容。追更日历也会在平台上同步展示。',
  },
  {
    q: '支持哪些设备观看？画质怎么样？',
    a: '情侣影院全面支持手机、平板和电脑多端观看，无需下载任何App，打开浏览器即可流畅追剧。全站剧集已升级至1080P高清画质，同时提供多种清晰度选择以适应不同网络环境，确保流畅不卡顿。',
  },
  {
    q: '如何找到适合情侣一起看的电视剧？',
    a: '情侣影院的剧集分类和专题推荐专为情侣追剧场景设计。你可以在首页浏览「精选推荐」和「专题聚焦」板块，也可以按类型（甜宠、都市、古装、悬疑等）快速筛选。每一部剧都标注了适合情侣观看的特点，帮你们快速找到心仪的好剧。',
  },
];

export default function FAQSection() {
  return (
    <section id="faq" className="py-16 md:py-24 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-800 mb-3">
            常见问题
          </h2>
          <p className="text-foreground-500 text-sm max-w-lg mx-auto">
            关于情侣影院的常见疑问，这里都有答案
          </p>
        </div>

        <div className="max-w-3xl mx-auto space-y-4">
          {faqData.map((item, idx) => (
            <div
              key={idx}
              className="bg-background-50 rounded-2xl p-6 border border-secondary-200/70"
            >
              <div className="flex items-start gap-4">
                <div className="w-8 h-8 flex-shrink-0 flex items-center justify-center rounded-lg bg-primary-100 text-primary-600 mt-0.5">
                  <span className="font-heading text-sm font-bold">Q</span>
                </div>
                <div className="flex-1">
                  <h3 className="font-heading text-base font-bold text-foreground-800 mb-3">{item.q}</h3>
                  <p className="text-foreground-500 text-sm leading-relaxed">{item.a}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}